import React from 'react'

export const CheckBox = ({type, name, checked, setChecked}) => {
    return (
        <>
            <input
                name={name}
                type={type}
                checked={checked}
                onChange={setChecked}
            />
        </>
    )
}